<template>
  <div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      案例精选
    </div>
    <div class="case_main">
      <div class="case_top">
        <div class="case_title">光大环保能源（南京）垃圾发电项目</div>
        <div class="case_time">
          <img
            src="../../assets/images/developerCommunity/dev_time.png"
            alt=""
          />
          <span>2020/06/12</span>
        </div>
        <hr />
      </div>
      <div class="case_detail">
        <div class="model">
          <div class="model_title">【企业介绍】</div>
          <div class="section">
            光大环境是全方位的环境综合治理服务商，主营业务包括垃圾发电及协同处理、生物质发电、危废及固废处置、环境修复、污水处理、中水回用、供水、水环境综合治理、垃圾分类、环卫一体化、资源循环利用、无废城市建设、节能照明、装备制造、分析检测、绿色技术研发、生态环境规划设计、环保产业园等。国内业务遍及23个省（市）、自治区的190多个地区；海外业务已布局德国、波兰及越南市场。
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目概况】</div>

          <div class="section">
            <img src="../../assets/nanjing/1.jpg" alt="" />
          </div>

          <div>
            <div class="section">
              设备资产管理主要面向设备管理者，洞悉目前平台的设备具体信息。设备管理者可以实时录入设备信息，在线查看设备在线状态，也可查看设备的详细运行参数及各项报警信息.
            </div>

            <div class="section">
              伴随光大环保能源（南京）垃圾焚烧发电项目一、二期投运，生产运行管控系统同步上线，实现现场两期工况数据的采集以及设备管理、运行管理、合同管理和数据报表等功能，借助公司在垃圾焚烧发电领域的专业认知和深度调研，该系统为光大南京项目带来良好的直接与间接经济效益。.
            </div>
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目效果】</div>
          <div class="section">
            通过生产管理系统的建设大大提升了日常办公的效率，同时在人员管理方面，由原来人盯人的方式改为系统盯人的方式，提高了管理效率，对人员考核也更加的公平公正和透明化。信息化的应用进一步规范了日常的工作流程，工作留痕，所有信息都有迹可寻，同时还实现了各部门间的信息共享，资料、信息统一化，查询、查阅更加便捷。平台为领导提供了有利的抓手，从而降低企业的管理成本，提升经济效益和企业形象。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaseTianjianDetail",
  data() {
    return {
      detailId: this.$route.params.id
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
  },
  methods: {
    init() {
      console.log(this.detailId);
    }
  }
};
</script>

<style lang="scss">
.carousel {
  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #ffffff;
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;
    img {
      width: 100%;
    }
    .model {
      margin-top: 0.2rem;
      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }
      .imageContainer {
        width: 100%;
        display: flex;
        justify-content: space-around;
        img {
          width: 242px;
        }
      }
      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseNanjingDetail.vue